import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Container,
  Grid,
  Card,
  CardHeader,
  CardContent,
  CircularProgress,
  Backdrop,
  Button,
  Typography,
  useTheme,
  CardActions,
  Stack,
  Icon,
  Paper,
} from "@mui/material";
import { useSnackbar } from "notistack";
import { GetNtf, ResponderNtf } from "../../redux/actions/notificaciones";
import { getCargando, getMensaje, getNtf } from "../../redux/selectors";
import { RemMensaje } from "../../redux/actions/mensajes";

import { useParams } from "react-router-dom";
import DialogoControles from "./dialogoControles";

const Ntf = (props) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const paramsIng = useParams();
  const { enqueueSnackbar /*, closeSnackbar*/ } = useSnackbar();
  const mensaje = useSelector((state) => getMensaje(state));
  const backdrop = useSelector((state) => getCargando(state));

  const [boton, setBoton] = React.useState(null);

  const [color, setColor] = React.useState({
    main: theme.palette.background.default,
    selected: "lightgray",
    pText: theme.palette.text.primary,
    sText: theme.palette.text.secondary,
    pText2: theme.palette.text.primary,
    sText2: theme.palette.text.secondary,
  });

  // Datos para la dejada de servicio -----------
  const ntfs = useSelector((state) => getNtf(state));
  //---------------------------------------------

  React.useEffect(() => {
    if (mensaje.mensaje !== "") {
      enqueueSnackbar(mensaje.mensaje, {
        preventDuplicate: true,
        anchorOrigin: { vertical: "bottom", horizontal: "center" },
        variant: mensaje.variant,
        autoHideDuration: 3000,
      });
      dispatch(RemMensaje());
    }
  }, [mensaje]);
  React.useEffect(() => {
    if (paramsIng.modo && paramsIng.modo === "1") {
      document.body.style.backgroundColor = "#2f3035";
      setColor({
        main: "#2f3035",
        pText: "white",
        sText: "#ACACAC",
        selected: "black",
        pText2: color.pText,
        sText2: color.sText,
      });
    }
    const p = {
      guid: paramsIng.guid,
      modo: paramsIng.modo,
      token: paramsIng.token,
    };
    dispatch(GetNtf(p));
  }, []);
  return (
    <>
      <Stack
        sx={{
          padding: theme.spacing(2, 0, 2),
          overflowY: "auto",
          maxHeight: "100vh",
        }}
      >
        <Container
          sx={{
            pt: 2,
            pb: 2,
          }}
        >
          <Backdrop
            sx={{
              zIndex: theme.zIndex.drawer + 1,
            }}
            open={backdrop}
          >
            <CircularProgress
              sx={{
                color: "#006699",
                m: "auto",
              }}
            />
          </Backdrop>
          <Grid
            sx={{ display: (backdrop && "none") || "inherits" }}
            container
            spacing={4}
          >
            {ntfs && !backdrop && ntfs.length === 0 && (
              <Grid key={1001} size={12}>
                <Card
                  sx={{
                    height: "100%",
                    minHeight: "100px",
                    display: "flex",
                    flexDirection: "column",
                  }}
                  variant="outlined"
                >
                  <CardHeader subheader={"No hay notificaciones para ver."} />
                </Card>
              </Grid>
            )}

            {ntfs &&
              ntfs.length > 0 &&
              ntfs.map((n, index) => {
                const boton = n.BOTONES.find((b) => b.VALOR === n.RESPUESTA);
                // const fondo = boton
                //   ? boton.FONDO
                //   : theme.palette.background.paper;
                // const color = boton ? boton.COLOR : "inherit";
                return (
                  <Grid key={"1001" + index} size={12}>
                    <Card
                      sx={{
                        height: "100%",
                        minHeight: "100px",
                        display: "flex",
                        flexDirection: "column",
                        backgroundColor: n.FONDO,
                        opacity: boton ? 0.8 : 1,
                      }}
                      variant="outlined"
                    >
                      <CardHeader
                        action={
                          boton &&
                          // boton.ICONO && (
                          //   <Avatar
                          //     sx={{ backgroundColor: fondo, color: color }}
                          //     variant="rounded"
                          //   >
                          //     <Icon>{boton && boton.ICONO}</Icon>
                          //   </Avatar>
                          // )
                          boton.CARTEL && (
                            <Typography
                              variant="caption"
                              sx={{
                                backgroundColor: boton.FONDO,
                                color: boton.COLOR,
                                p: 1,
                                borderRadius: 3,
                              }}
                            >
                              {boton.CARTEL}
                            </Typography>
                          )
                        }
                        // sx={{ color: color }}
                        title={n.TITULO}
                        titleTypographyProps={{ variant: "h6" }}
                        subheaderTypographyProps={{
                          // color: color,
                          fontSize: "small",
                        }}
                        // subheader={
                        //   <Stack direction="row" sx={{ p: 0, pr: 2 }}>
                        //     <Typography variant="caption">
                        //       {DateFormat(
                        //         new Date(n.FECHA),
                        //         "dd/MM/yyyy HH:mm",
                        //       )}
                        //     </Typography>
                        //   </Stack>
                        // }
                      />
                      <CardContent sx={{ pt: 0 }}>
                        <Stack direction="column">
                          <Typography
                            dangerouslySetInnerHTML={{ __html: n.CUERPO }}
                          />
                          {boton && n.RESPUESTAS && n.RESPUESTAS.length > 0 && (
                            <Paper variant="outlined" sx={{ p: 1, mt: 2 }}>
                              <Typography fontWeight="bold" variant="caption">
                                {"Respuesta" +
                                  (n.RESPUESTAS.length === 1 ? "" : "s")}
                              </Typography>

                              {n.RESPUESTAS.map((r, index) => (
                                <Stack
                                  marginLeft={2}
                                  direction="row"
                                  spacing={0.5}
                                  key={"resp" + n.ID_ORIGEN + "." + index}
                                >
                                  <Typography
                                    fontWeight="bold"
                                    variant="caption"
                                  >
                                    {r.DESCRIPCION}
                                  </Typography>
                                  <Typography variant="caption">
                                    {r.VALOR}
                                  </Typography>
                                </Stack>
                              ))}
                            </Paper>
                          )}
                        </Stack>
                      </CardContent>
                      {!boton && n.BOTONES && n.BOTONES.length > 0 && (
                        <CardActions sx={{ justifyContent: "flex-end" }}>
                          {n.BOTONES.map((b) => (
                            <Button
                              size="small"
                              variant="contained"
                              startIcon={
                                b.ICONO && (
                                  <Icon fontSize="small">{b.ICONO}</Icon>
                                )
                              }
                              sx={{ backgroundColor: b.FONDO, color: b.COLOR }}
                              onClick={() =>
                                setBoton({ ...b, NTF: n.ID_NOTIFICACION })
                              }
                            >
                              {b.DESCRIPCION}
                            </Button>
                          ))}
                        </CardActions>
                      )}
                    </Card>
                  </Grid>
                );
              })}
          </Grid>
        </Container>
      </Stack>

      {Boolean(boton) && (
        <DialogoControles
          boton={boton}
          onSave={(v) =>
            dispatch(
              ResponderNtf({
                ...v,
                guid: paramsIng.guid,
                modo: paramsIng.modo,
              }),
            )
          }
          onClose={() => setBoton(null)}
        />
      )}
    </>
  );
};

export default Ntf;
